import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'
import clsx from 'clsx'

import { ArrowAll16, Edit16 } from '@makyoapp/makyo-icon/icon'
import { DD } from '@makyoapp/makyo-ui'

import { useVariableSelectContext } from '../VariableSelectContext'

export function DragHandler({ listeners }: { listeners?: SyntheticListenerMap }) {
  const { multiple } = useVariableSelectContext()
  return multiple ? (
    <button {...listeners} className='text-zinc-400 dark:text-slate-400'>
      <ArrowAll16 />
    </button>
  ) : null
}

export function EditDD({
  show,
  onToggle,
  className,
  menuWrapperClassName,
  menuClassName,
  children,
}: {
  show: boolean
  onToggle: (nextShow: boolean, meta: any) => void
  className?: string
  menuWrapperClassName?: string
  menuClassName?: string
  children?: React.ReactNode
}) {
  return (
    <DD
      className={clsx('flex-cc', className)}
      show={show}
      menuAlwaysRender={false}
      onToggle={(nextShow, meta) => {
        const evt = meta.originalEvent
        const tgt = evt?.target as HTMLElement
        if (
          tgt?.closest('.sdd-search-wrap') ||
          tgt?.tagName === 'INPUT' ||
          tgt?.className?.includes?.('search-input')
        ) {
          return
        }
        onToggle(nextShow, meta)
      }}
      toggleNoButton
      toggleClassName='inline-flex'
      toggle={(active, toggleProps) => {
        return (
          <button className={clsx('text-primary-500 mt-1')} {...toggleProps}>
            <Edit16 />
          </button>
        )
      }}
      menuWrapperClassName={clsx('sdd-menu-subc', menuWrapperClassName)}
      menuClassName={clsx(menuClassName, 'z-301')}
      menuDefaultSize={false}
      menuNoPad
      placement='auto'
      portalMenu={true}
    >
      <div className='text-m-m text-zinc-700 dark:text-slate-300'>{children}</div>
    </DD>
  )
}
